import api from "./client";

function getActiveLocationId() {
  try {
    const loc = JSON.parse(localStorage.getItem("activeLocation") || "null");
    return String(loc?.id || loc?._id || "").trim();
  } catch (_err) {
    return "";
  }
}

function viHeaders() {
  const locationId = getActiveLocationId();
  return locationId ? { "X-Active-Location-Id": locationId } : {};
}

export async function fetchViIntegrationStatus() {
  const response = await api.get("/integrations/vital-insights/status", {
    headers: viHeaders(),
  });
  return response.data;
}

export async function startVitalInsightsSso() {
  const response = await api.post(
    "/integrations/vital-insights/sso",
    {},
    { headers: viHeaders() },
  );
  return response.data;
}

export async function fetchViClientSnapshot(clientId, { refresh = false, limit = 20 } = {}) {
  const params = { refresh: refresh ? "1" : "0", limit };
  if (refresh) {
    params._t = Date.now();
  }
  const response = await api.get(
    `/integrations/vital-insights/clients/${clientId}/snapshot`,
    {
      headers: {
        ...viHeaders(),
        ...(refresh ? { "Cache-Control": "no-cache", Pragma: "no-cache" } : {}),
      },
      params,
    },
  );
  return response.data;
}

export async function autoMatchViClient(clientId, { force = false } = {}) {
  const response = await api.post(
    `/integrations/vital-insights/clients/${clientId}/match`,
    force ? { force: true } : {},
    {
      headers: viHeaders(),
      params: force ? { force: "1" } : {},
      timeout: 90000,
    },
  );
  return response.data;
}

export async function manualLinkViClient(clientId, hearthClientId, hearthClientName = "") {
  const response = await api.post(
    `/integrations/vital-insights/clients/${clientId}/link`,
    { hearthClientId, hearthClientName },
    { headers: viHeaders() },
  );
  return response.data;
}
